import React, { useState } from 'react';
import { ScrollView, View } from 'react-native';
import { Auth as Authorization } from 'aws-amplify';
import { Button, FormControl, Input, VStack, Text, Box } from 'native-base';
import { containerStyle } from 'src/styles/containerStyle';
import { inputStyle } from 'src/styles/inputStyle';
import ProgressBar from 'src/components/ProgressBar';
import InweonLogo from 'src/components/InweonLogo';
import { formProps } from 'src/styles/formProps';
import { getText } from 'src/utils/i18n';

interface ForgotPasswordFormState {
    username: string,
}

export default function ForgotPasswordPage({ navigation }) {

    const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);
    const [formData, setData] = React.useState<ForgotPasswordFormState>({
        username: ''
    });

    const [errors, setErrors] = React.useState({});

    const validate = () => {
        if (formData.username === undefined
            || formData.username.length === 0) {
            setErrors({
                username: getText('usernameRequired')
            });
            return false;
        }
        return true;
    };

    const handleForgotPassword = async () => {
        setShowLoadingIndicator(true)
        Authorization.forgotPassword(formData.username).then(async () => {
            setShowLoadingIndicator(true)
            navigation.navigate('ConfirmForgotPassword', {
                "username": formData.username
            })
        }).catch((e) => {
            console.log('error occurred', e)

            setErrors({
                formError: e.message
            });

            setShowLoadingIndicator(false)
        });
    }

    const onSubmit = () => {
        const isValid = validate();
        if (isValid) {
            // submit the data
            handleForgotPassword()
        }
    };

    return (
        <Box variant={"main"} style={containerStyle.mainContainer}>
            <ProgressBar isVisible={showLoadingIndicator} progressText={getText('loading')} />
            <ScrollView automaticallyAdjustKeyboardInsets={true}>
                <InweonLogo title={getText('resetPasswordTitle')} />

                <VStack width={formProps.width}
                    style={containerStyle.formContainer} mx="3">
                    <FormControl isRequired>
                        <FormControl.Label>Username</FormControl.Label>
                        <Input
                            style={inputStyle.nativeInput}
                            isInvalid={'username' in errors}
                            placeholder={getText('usernamePlaceholder')}
                            onSubmitEditing={onSubmit}
                            onChangeText={value => setData({
                                ...formData,
                                username: value
                            })} />
                        {'username' in errors ? <FormControl.ErrorMessage>{errors['username']}</FormControl.ErrorMessage> : null}
                    </FormControl>
                    <Button onPress={onSubmit} mt="5">
                        Send confirmation code
                    </Button>
                    {'formError' in errors ? <Text color="red.500" mt="2">{errors['formError'] || ""}</Text> : null}
                </VStack>
            </ScrollView>

        </Box>
    );
}